import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function Card(props: IconProps = {}): JSX.Element {
  const { ...rest } = props;

  return (
    <SvgIcon name="Card" {...rest}>
      <rect
        x="1"
        y="4"
        width="22"
        height="16"
        rx="1"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M2 10H23" stroke="currentColor" strokeWidth="4" />
    </SvgIcon>
  );
}
